
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/new",
      function () {
        return require("private-next-pages/groups/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/new"])
      });
    }
  